import { MEASURE_UNIT_WIND_SPEED_ZONE } from '@/features/measure/consts/unit'
import i18n from '@/i18n'

const { kn_m2 } = MEASURE_UNIT_WIND_SPEED_ZONE

type OptionType = {
  label: string
  value: MEASURE_UNIT_WIND_SPEED_ZONE
}

const localeData: any = {
  en: {
    [kn_m2]: 'kN/m²',
  },
  de: {
    [kn_m2]: 'kN/m²',
  },
}

const locale = (code: string) => {
  return localeData[code]
}

export const getWindSpeedZoneUnits = (): OptionType[] => {
  const code = i18n.language

  return [
    {
      label: locale(code).kn_m2,
      value: kn_m2,
    },
  ]
}

export const windSpeedZoneUnitsMap = getWindSpeedZoneUnits().reduce((acc: any, curr) => {
  const { value } = curr

  return acc.set(value, curr)
}, new Map())
